import { render, staticRenderFns } from "./BaseTabControl.vue?vue&type=template&id=1c8c22fe&scoped=true&"
import script from "./BaseTabControl.vue?vue&type=script&lang=ts&"
export * from "./BaseTabControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c22fe",
  null
  
)

export default component.exports